import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var myAudit = [{
  path: "my-audit",
  name: "my-audit",
  component: function component() {
    return import("./my-audit.vue");
  }
}];